import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import api from '../services/api';
import axios from 'axios'; // TODO: rimuovere, usare api
import { toast } from 'react-toastify';

const NewLeadPage = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  
  // Stato per il form
  const [formData, setFormData] = useState({
    cliente: {
      id: '',
      nome: '',
      ragioneSociale: '',
      codiceFiscale: '',
      status: ''
    },
    provenienza: {
      fonte: '',
      dettaglioProvenienza: ''
    },
    dettagli: {
      convenzione: 'NESSUNA',
      dataCreazione: formatDate(new Date()),
      oraCreazione: formatTime(new Date()),
      note: ''
    }
  });
  
  // Stati per le opzioni dei select
  const [clienti, setClienti] = useState([]);
  const [fonti, setFonti] = useState([]);
  const [dettagliProvenienza, setDettagliProvenienza] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [clientSearchResults, setClientSearchResults] = useState([]);
  const [clientSelected, setClientSelected] = useState(false);
  
  // Formatta la data nel formato GG/MM/AAAA
  function formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  }
  
  // Formatta l'ora nel formato HH:MM
  function formatTime(date) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    
    return `${hours}:${minutes}`;
  }
  
  // Carica i dati iniziali
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Chiamata API per ottenere le fonti
        const response = await api.get('/lead/fonti');
        setFonti(response.data.data || []);
      } catch (error) {
        console.error('Errore nel caricamento dei dati:', error);
      }
    };
    
    fetchData();
  }, []);
  
  // Carica i dettagli di provenienza quando cambia la fonte
  useEffect(() => {
    if (formData.provenienza.fonte) {
      const fetchDettagli = async () => {
        try {
          // Chiamata API per ottenere i dettagli di provenienza in base alla fonte selezionata
          const response = await api.get(`/lead/dettagli-provenienza/${formData.provenienza.fonte}`);
          setDettagliProvenienza(response.data.data || []);
        } catch (error) {
          console.error('Errore nel caricamento dei dettagli:', error);
        }
      };
      
      fetchDettagli();
    } else {
      setDettagliProvenienza([]);
    }
  }, [formData.provenienza.fonte]);
  
  // Cerca i clienti
  const searchClients = async (term) => {
    if (term.length < 3) {
      setClientSearchResults([]);
      return;
    }
    
    try {
      // Chiamata API per cercare i clienti
      const response = await api.get(`/clients/search?term=${term}`);
      setClientSearchResults(response.data);
    } catch (error) {
      console.error('Errore nella ricerca dei clienti:', error);
      setClientSearchResults([]);
    }
  };
  
  // Gestisce la modifica dei campi del form
  const handleInputChange = (section, field, value) => {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value
      }
    }));
  };
  
  // Seleziona un cliente
  const handleSelectClient = (client) => {
    setFormData(prev => ({
      ...prev,
      cliente: client
    }));
    setClientSelected(true);
    setClientSearchResults([]);
    setSearchTerm('');
  };
  
  // Rimuovi la selezione del cliente
  const handleRemoveClient = () => {
    setFormData(prev => ({
      ...prev,
      cliente: {
        id: '',
        nome: '',
        ragioneSociale: '',
        codiceFiscale: '',
        status: ''
      }
    }));
    setClientSelected(false);
  };
  
  // Gestisce l'invio del form
  const handleSubmit = async (finalSubmit = false) => {
    // Verifica che i dati obbligatori siano presenti
    if (step === 1 && !clientSelected) {
      toast.warning("Seleziona un cliente prima di continuare");
      return;
    }
    
    if (step === 2 && !formData.provenienza.fonte) {
      toast.warning("Seleziona una fonte prima di continuare");
      return;
    }
    
    if (step < 3 && !finalSubmit) {
      // Vai al prossimo step
      setStep(step + 1);
      return;
    }
    
    // Verifica finale dei dati obbligatori
    if (!formData.dettagli.dataCreazione || !formData.dettagli.oraCreazione) {
      toast.warning("Inserisci data e ora di creazione");
      return;
    }
    
    setLoading(true);
    
    try {
      // Invia i dati al server
      await api.post('/lead/create', formData);
      
      setLoading(false);
      // Redirect alla lista delle lead
      navigate('/nlt/lead');
    } catch (error) {
      console.error('Errore nel salvataggio dei dati:', error);
      setLoading(false);
      toast.error("Si è verificato un errore durante il salvataggio. Riprova.");
    }
  };
  
  // Gestisce il click sul pulsante Annulla
  const handleCancel = () => {
    // Conferma con toast personalizzato
    const confermaAnnullamento = () => {
      toast.dismiss();
      
      toast(
        ({ closeToast }) => (
          <div>
            <p className="mb-3">Sei sicuro di voler annullare? Tutti i dati inseriti andranno persi.</p>
            <div className="flex space-x-2">
              <button
                onClick={() => {
                  closeToast();
                  navigate('/nlt/lead');
                }}
                className="px-3 py-1 bg-red-600 text-white rounded text-sm hover:bg-red-700"
              >
                Annulla e Perdi Dati
              </button>
              <button
                onClick={closeToast}
                className="px-3 py-1 bg-gray-300 text-gray-700 rounded text-sm hover:bg-gray-400"
              >
                Continua Modifica
              </button>
            </div>
          </div>
        ),
        {
          position: "top-center",
          autoClose: false,
          hideProgressBar: true,
          closeOnClick: false,
          draggable: false,
        }
      );
    };
    
    confermaAnnullamento();
  };
  
  return (
    <div className="p-6 max-w-[1800px] mx-auto">
      {/* Link per tornare indietro */}
      <div className="mb-6">
        <Link
          to="/nlt/lead"
          className="inline-flex items-center text-blue-600 hover:text-blue-800"
        >
          <ArrowLeftIcon className="h-4 w-4 mr-1" />
          <span className="text-sm">LISTA NUOVE OPPORTUNITÀ</span>
        </Link>
      </div>
      
      {/* Form container */}
      <div className="bg-white shadow rounded-lg overflow-hidden">
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b">
          <h1 className="text-xl font-medium text-gray-900">Creazione nuova opportunità</h1>
          <div>
            <button
              type="button"
              className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 mr-2"
              onClick={handleCancel}
            >
              ANNULLA
            </button>
            {step === 3 && (
              <>
                <button
                  type="button"
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 mr-2"
                  onClick={() => handleSubmit(false)}
                  disabled={loading}
                >
                  SALVA E APRI
                </button>
                <button
                  type="button"
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                  onClick={() => handleSubmit(true)}
                  disabled={loading}
                >
                  SALVA E CHIUDI
                </button>
              </>
            )}
          </div>
        </div>
        
        {/* Contenuto del form */}
        <div className="p-6">
          {/* Step 1: Cliente */}
          {step === 1 && (
            <div>
              <h2 className="text-lg font-medium text-gray-900 mb-6">1. Cliente</h2>
              
              {!clientSelected ? (
                <div>
                  <p className="mb-4">Cerca cliente</p>
                  <div className="flex items-center mb-6">
                    <input
                      type="text"
                      className="flex-1 p-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Rag. sociale, cod. cliente, p. iva..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        searchClients(e.target.value);
                      }}
                    />
                    <button
                      type="button"
                      className="px-4 py-2 bg-blue-600 text-white rounded-r-md hover:bg-blue-700"
                      onClick={() => searchClients(searchTerm)}
                    >
                      CERCA
                    </button>
                  </div>
                  
                  {clientSearchResults.length > 0 ? (
                    <div className="mb-6">
                      {clientSearchResults.map((client) => (
                        <div
                          key={client.id}
                          className="border border-gray-300 rounded-md p-4 mb-2 hover:bg-gray-50 cursor-pointer"
                          onClick={() => handleSelectClient(client)}
                        >
                          <div className="grid grid-cols-4 gap-4">
                            <div>
                              <p className="text-sm font-medium">Nome</p>
                              <p className="text-sm">{client.nome}</p>
                            </div>
                            <div>
                              <p className="text-sm font-medium">Ragione Sociale</p>
                              <p className="text-sm">{client.ragioneSociale}</p>
                            </div>
                            <div>
                              <p className="text-sm font-medium">Codice Fiscale</p>
                              <p className="text-sm">{client.codiceFiscale}</p>
                            </div>
                            <div>
                              <p className="text-sm font-medium">ID Cliente</p>
                              <p className="text-sm">{client.idCliente}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : searchTerm.length >= 3 ? (
                    <div className="text-center py-8">
                      <p className="text-gray-600">Non ci sono clienti</p>
                    </div>
                  ) : null}
                </div>
              ) : (
                <div className="border border-gray-300 rounded-md p-4 mb-6 relative">
                  <button
                    type="button"
                    className="absolute top-2 right-2 text-red-600 hover:text-red-800"
                    onClick={handleRemoveClient}
                  >
                    ×
                  </button>
                  <div className="grid grid-cols-5 gap-4">
                    <div>
                      <p className="text-sm text-gray-500">Nome</p>
                      <p className="font-medium">{formData.cliente.nome}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Ragione Sociale</p>
                      <p className="font-medium">{formData.cliente.ragioneSociale}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Codice Fiscale</p>
                      <p className="font-medium">{formData.cliente.codiceFiscale}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">ID Cliente</p>
                      <p className="font-medium">{formData.cliente.idCliente}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Status</p>
                      <p className="font-medium">{formData.cliente.status}</p>
                    </div>
                  </div>
                </div>
              )}
              
              <div className="mt-8 flex justify-end">
                <button
                  type="button"
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                  onClick={() => handleSubmit(false)}
                  disabled={!clientSelected}
                >
                  AVANTI
                </button>
              </div>
            </div>
          )}
          
          {/* Step 2: Provenienza contatto */}
          {step === 2 && (
            <div>
              <h2 className="text-lg font-medium text-gray-900 mb-6">2. Provenienza contatto</h2>
              
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Fonte <span className="text-red-600">*</span>
                </label>
                <select
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  value={formData.provenienza.fonte}
                  onChange={(e) => handleInputChange('provenienza', 'fonte', e.target.value)}
                  required
                >
                  <option value="">Seleziona una fonte</option>
                  {fonti.map((fonte) => (
                    <option key={fonte.id} value={fonte.id}>
                      {fonte.descrizione}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Dettaglio provenienza contatto <span className="text-red-600">*</span>
                </label>
                <select
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  value={formData.provenienza.dettaglioProvenienza}
                  onChange={(e) => handleInputChange('provenienza', 'dettaglioProvenienza', e.target.value)}
                  disabled={!formData.provenienza.fonte}
                  required
                >
                  <option value="">Seleziona un dettaglio</option>
                  {dettagliProvenienza.map((dettaglio) => (
                    <option key={dettaglio.id} value={dettaglio.id}>
                      {dettaglio.descrizione}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="mt-8 flex justify-between">
                <button
                  type="button"
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
                  onClick={() => setStep(1)}
                >
                  INDIETRO
                </button>
                <button
                  type="button"
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                  onClick={() => handleSubmit(false)}
                  disabled={!formData.provenienza.fonte || !formData.provenienza.dettaglioProvenienza}
                >
                  AVANTI
                </button>
              </div>
            </div>
          )}
          
          {/* Step 3: Dettagli */}
          {step === 3 && (
            <div>
              <h2 className="text-lg font-medium text-gray-900 mb-6">3. Dettagli</h2>
              
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Convenzione
                </label>
                <div>
                  <button
                    type="button"
                    className={`px-4 py-2 rounded-md ${
                      formData.dettagli.convenzione === 'NESSUNA'
                        ? 'bg-gray-200 font-medium'
                        : 'bg-white border border-gray-300'
                    }`}
                    onClick={() => handleInputChange('dettagli', 'convenzione', 'NESSUNA')}
                  >
                    NESSUNA
                  </button>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Data creazione <span className="text-red-600">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      className="w-full p-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      value={formData.dettagli.dataCreazione}
                      onChange={(e) => handleInputChange('dettagli', 'dataCreazione', e.target.value)}
                      placeholder="GG/MM/AAAA"
                      required
                    />
                    <button
                      type="button"
                      className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                    >
                      <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </button>
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Ora creazione <span className="text-red-600">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      className="w-full p-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      value={formData.dettagli.oraCreazione}
                      onChange={(e) => handleInputChange('dettagli', 'oraCreazione', e.target.value)}
                      placeholder="HH:MM"
                      required
                    />
                    <button
                      type="button"
                      className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                    >
                      <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Note <span className="text-xs text-gray-500 font-normal">(0/250)</span>
                </label>
                <textarea
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  rows="4"
                  value={formData.dettagli.note}
                  onChange={(e) => handleInputChange('dettagli', 'note', e.target.value)}
                  maxLength={250}
                />
              </div>
              
              <div className="mt-8 flex justify-between">
                <button
                  type="button"
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
                  onClick={() => setStep(2)}
                >
                  INDIETRO
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewLeadPage; 